<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()">
    <!-- Content -->
    <mat-list *ngIf="errors">
        <mat-list-item *ngFor="let error of errors" class="fit-content">
            <mat-icon matListIcon>{{error.icon}}</mat-icon>
            <h3 matLine> {{error.message}} </h3>
        </mat-list-item>
    </mat-list>
    <!-- Content -->
</wtf-dialogcontent>